import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconRight from '../../assets/images/icon_right.png';

const ChartCardContainer = ({
  title,
  children,
  className = '',
  showActions = true,
  onIconClick,
  defaultCollapsed = false
}) => {
  const { t } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const handleToggle = () => {
    setIsCollapsed(!isCollapsed);
    if (onIconClick) {
      onIconClick(!isCollapsed);
    }
  };

  return (
    <div className={`chart-card-container ${className} ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Header */}
      <div className="chart-card-header">
        <div className="chart-card-title-section">
          <div className="chart-card-grid-icon drag-handle">
            <div className="grid-dots">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <h2 className="chart-card-title">{title}</h2>
        </div>

        {showActions && (
          <div className="chart-card-actions" onClick={handleToggle}>
            <img
              src={IconRight}
              alt={t("charts.toggle")}
              className={`action-icon ${isCollapsed ? 'collapsed' : ''}`}
              style={{ cursor: 'pointer' }}
            />
          </div>
        )}
      </div>

      {/* Content */}
      <div className={`chart-card-content ${isCollapsed ? 'collapsed' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default ChartCardContainer;
